import { useEffect } from 'react';

export function useScrollReveal() {
  useEffect(() => {
    const revObs = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            revObs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const els = document.querySelectorAll(
      '.sol-block,.hiw-step,.ind-card,.why-card,.testi-card,.animate-on-scroll'
    );
    els.forEach(el => revObs.observe(el));

    return () => revObs.disconnect();
  }, []);
}
